<template>
  <component :is="tag" v-on="$listeners">
    <div class="chat-info flex-grow-1">
      <div class="d-flex align-items-center">
        <h5 class="chat-name">
          {{ young.lastName }} {{ young.firstName }}
          <feather-icon v-if="young.isBlocked" icon="MinusCircleIcon" fill="red" stroke="white" size="18" />
          <b-badge v-if="young.unreadMessages" pill variant="primary" class="ml-1 unread-badge">
            {{ young.unreadMessages }}
          </b-badge>
        </h5>
      </div>
      <p class="chat-name unique-number">
        #{{ young.uniqueYoungNumber }}
      </p>
      <div class="d-flex align-items-center card-text text-truncate">
        <feather-icon icon="SmartphoneIcon" />
        <span class="phone-number mr-2">{{ formatPhoneNumber(young.phoneNumber) }}</span>
        <template v-if="young.zipCode">
          <feather-icon icon="MapPinIcon" />
          {{ young.zipCode.substring(0, 2) }}
        </template>
      </div>
    </div>

    <div class="chat-meta text-nowrap d-flex align-items-end flex-column">
      <b-badge v-if="young.hasPendingMessage && showStatusBadges" class="status-badge status-badge--pending mb-25">
        En attente
      </b-badge>
      <b-badge v-else-if="young.conversationStatus === 2 && showStatusBadges" class="status-badge status-badge--taken mb-25">
        Pris en charge
      </b-badge>
      <b-badge v-else-if="young.conversationStatus === 3 || young.conversationStatus === 4" class="status-badge status-badge--archived mb-25">
        Archivée
      </b-badge>
      <small class="mb-25 chat-time">{{ formatDateToMonthShort(young.lastActivityDate, {
        hour: 'numeric', minute: 'numeric'
      }) }}</small>
      <initials-avatar v-if="young.lastMessageUser != null" size="26" :family-name="young.lastMessageUser.lastName"
                       :given-name="young.lastMessageUser.firstName" :show-title="true" />
    </div>
  </component>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatDateToMonthShort, formatPhoneNumber } from '@core/utils/filter'
import InitialsAvatar from '@/components/InitialsAvatar.vue'
import store from '@/store'

export default {
  components: {
    BBadge,
    InitialsAvatar,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    young: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const currentUser = computed(() => store.getters['users/currentUser'])
    const currentUserRoles = computed(() => currentUser.value?.roles || [])
    const isEcoutant = computed(() => currentUserRoles.value.includes('LeRefuge.Ecoutant'))
    // Hide messaging-related badges for Ecoutants who don't have the messaging feature enabled
    const showStatusBadges = computed(
      () => !isEcoutant.value || currentUser.value?.profile?.canSendMessage === true,
    )

    return {
      formatDateToMonthShort,
      formatPhoneNumber,
      showStatusBadges,
    }
  },
}
</script>

<style>
.blocked {
  align-self: end;
}
.unique-number {
  text-align: start;
  color: #6dc3e0;
  font-weight: 900;
}
.unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  line-height: 1;
  min-width: 1.4em;
  height: 1.4em;
  padding: 0 0.4em;
}
.status-badge {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding: 0.3em 0.6em;
  border-radius: 4px;
  white-space: nowrap;
  text-transform: uppercase;
}
.status-badge--pending {
  background-color: rgba(255, 159, 67, 0.15);
  color: #e07c00;
  border: 1px solid rgba(255, 159, 67, 0.4);
}
.status-badge--taken {
  background-color: rgba(40, 199, 111, 0.12);
  color: #1a8a4a;
  border: 1px solid rgba(40, 199, 111, 0.35);
}
.status-badge--archived {
  background-color: rgba(115, 103, 240, 0.1);
  color: #6b5fcf;
  border: 1px solid rgba(115, 103, 240, 0.3);
}
/* dark mode */
.dark-layout .status-badge--pending {
  background-color: rgba(255, 159, 67, 0.18);
  color: #ffb347;
  border-color: rgba(255, 159, 67, 0.45);
}
.dark-layout .status-badge--taken {
  background-color: rgba(40, 199, 111, 0.15);
  color: #3ecf7e;
  border-color: rgba(40, 199, 111, 0.4);
}
.dark-layout .status-badge--archived {
  background-color: rgba(115, 103, 240, 0.15);
  color: #a89cf7;
  border-color: rgba(115, 103, 240, 0.4);
}
</style>
